import { render, staticRenderFns } from "./SubscriptionChurch.vue?vue&type=template&id=0b899444&scoped=true&"
import script from "./SubscriptionChurch.vue?vue&type=script&lang=js&"
export * from "./SubscriptionChurch.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionChurch.vue?vue&type=style&index=0&id=0b899444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b899444",
  null
  
)

export default component.exports